exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\r\n.media-controls-play .glyphicon {\r\n    color : black;\r\n    font-size: 26px;\r\n    vertical-align: middle;\r\n    padding-bottom: 4px;\r\n}\r\n\r\n.media-controls-play .glyphicon:hover {\r\n    color: dimgray;\r\n    cursor: pointer;\r\n}", ""]);

